import { dispatch, useReframe } from 'nike-re-framejs';
import { isGlobalFavoriteMarket$$, isFavoriteMatch$$, isFavoriteTournament$$ } from './subs';
import { toggleFavoriteMarketGlobal, toggleFavoriteMatch, toggleFavoriteTournament } from './handlers';

export const useFavoriteMatch = (sportCode, match) => {
    const derefSub = useReframe();
    if (!match) {
        return { isFavorite: false, disabledFavorite: false, toggleFavorite: () => null };
    }
    const isFavoriteMatch = derefSub(isFavoriteMatch$$(match.get('id')));
    const isFavoriteTournament = derefSub(isFavoriteTournament$$(match.get('tournamentId')));
    return {
        isFavorite: isFavoriteMatch,
        disabledFavorite: isFavoriteTournament,
        toggleFavorite: () => dispatch(toggleFavoriteMatch(sportCode, match))
    };
};

export const useFavoriteTournament = (sportCode, tournament) => {
    const derefSub = useReframe();
    if (!sportCode || !tournament) {
        return { isFavorite: false, toggleFavorite: () => null };
    }
    const isFavorite = derefSub(isFavoriteTournament$$(tournament.get('id')));
    return {
        isFavorite,
        toggleFavorite: () => dispatch(toggleFavoriteTournament(sportCode, tournament))
    };
};

// Manage global favorite markets
export const useFavoriteMarket = marketId => {
    const derefSub = useReframe();
    const isFavorite = derefSub(isGlobalFavoriteMarket$$(marketId));
    return {
        isFavorite,
        toggleFavorite: () => dispatch(toggleFavoriteMarketGlobal(marketId))
    };
};
